<script lang="ts">
  import '../app.postcss';
  import { plausible } from '$lib/plausible';
  import { onMount } from 'svelte';

  onMount(() => {
    const cleanupPageViews = plausible.enableAutoPageviews();

    return () => {
      cleanupPageViews();
    };
  });
</script>

<svelte:head>
  <title>Bee with Friends</title>
  <script async src="https://www.googletagmanager.com/gtag/js?id=G-TMETM7TK8Q"></script>
  <script>
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-TMETM7TK8Q');
  </script>
</svelte:head>
<slot />
